import spinner from '../assets/ss.svg'
import banner_bg from '../assets/banner_bg_comp.png'

export default {
  banner_bg,
  spinner
}
